import { render, staticRenderFns } from "./UploadIcon.vue?vue&type=template&id=b481e9be&scoped=true"
import script from "./UploadIcon.vue?vue&type=script&lang=js"
export * from "./UploadIcon.vue?vue&type=script&lang=js"
import style0 from "./UploadIcon.vue?vue&type=style&index=0&id=b481e9be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../.pnpm-store/v11/links/@/vue-loader/15.11.1/6eff93d7107be10a36f1ed991dd8c448aca9b1ca7fe7bab80a7f2c3e35a8f285/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b481e9be",
  null
  
)

export default component.exports